import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { resetPassword } from '../../actions/index';
import ResetPassView from './ResetPassView';

class ResetPassContainer extends Component {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    location: PropTypes.shape({ search: PropTypes.string.isRequired }).isRequired,
    onResetPassword: PropTypes.func.isRequired,
  };

  resetPassword = password => {
    const {
      onResetPassword,
      location: { search },
    } = this.props;

    // React Router v5 uses location.search — location.query (v3) is undefined in v5
    const token = new URLSearchParams(search).get('token');

    onResetPassword(token, password);
  };

  render() {
    const { loading } = this.props;

    return <ResetPassView resetPassword={this.resetPassword} loading={loading} />;
  }
}

function mapStateToProps(state) {
  return {
    loading: state.auth.loading,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    onResetPassword: (token, password) => dispatch(resetPassword(token, password)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ResetPassContainer);
